import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  static targets = ['panel', 'toggler', 'backdrop']

  togglerTargetConnected = (element) => {
    element.addEventListener('click', e => this.toggle(e.currentTarget))
  }

  togglerTargetDisconnected = (element) => {
    element.removeEventListener('click', this.toggle)
  }

  backdropTargetConnected = (element) => {
    element.addEventListener('click', this.close)
  }

  backdropTargetDisconnected = (element) => {
    element.removeEventListener('click', this.close)
  }

  connect = () => {
    on('toggleSidebar', this.toggleSidebar)
    document.addEventListener('keydown', this.handleEsc)
  }

  disconnect = () => {
    off('toggleSidebar', this.toggleSidebar)
    document.removeEventListener('keydown', this.handleEsc)
  }

  toggle = (element) => {
    const isHidden = this.panelTarget.classList.contains('-translate-x-full')
      || this.panelTarget.classList.contains('md:-translate-x-full')
    isHidden ? this.open(element) : this.close()
  }

  open = (element) => {
    this.panelTarget.classList.remove('-translate-x-full', 'md:-translate-x-full')
    this.panelTarget.classList.add('translate-x-0')
    this.backdropTarget.classList.remove('hidden')
    element?.querySelector('.hamburger-icon')?.classList.add('is-open')
  }

  close = () => {
    this.panelTarget.classList.remove('translate-x-0', 'md:translate-x-0')
    this.panelTarget.classList.add('-translate-x-full')
    this.backdropTarget.classList.add('hidden')
    document.querySelectorAll('.hamburger-icon').forEach(el => el.classList.remove('is-open'))
  }

  toggleSidebar = () => {
    this.element.classList.toggle('hidden')
    this.element.classList.toggle('absolute')
  }

  handleEsc = (event) => {
    if (event.key !== 'Escape') return
    if (this.panelTarget.dataset.sidebarPermanent === 'true' && window.innerWidth >= 768) return
    this.close()
  }
}
